import {put, takeLatest} from "redux-saga/effects";
import {getUserByToken} from "./crud";

export const actionTypes = {
  Login: "Auth.Login",
  Logout: "Auth.Logout",
  Register: "Auth.Register",
  EditMyInfo: "Auth.EditMyInfo",
  RefreshToken: "Auth.RefreshToken",
  UserRequested: "Auth.UserRequested",
  UserLoaded: "Auth.UserLoaded"
};

export const actions = {
  login: authToken => ({type: actionTypes.Login, payload: {authToken}}),
  register: authToken => ({type: actionTypes.Register, payload: {authToken}}),
  editMyInfo: user => ({type: actionTypes.EditMyInfo, payload: {user}}),
  refreshToken: authToken => ({type: actionTypes.RefreshToken, payload: {authToken}}),
  requestUser: user => ({type: actionTypes.UserRequested, payload: {user}}),
  fulfillUser: user => ({type: actionTypes.UserLoaded, payload: {user}}),
  logout: () => ({type: actionTypes.Logout}),
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    const user = yield getUserByToken();
    yield put(actions.fulfillUser(user));
  });
}
